
import request from '../utils/request'


//首页展示新闻简略信息
function getHomeNews(data){
    return request({
        url : '/newsInfo/getHomeNews',
        method : 'post',
        data
    });
}

//新闻分页列表
function getPageNews(data){
    return request({
        url : '/newsInfo/getPageNews',
        method : 'post',
        data,
    });
}

function selectByHomeId(data){
    return request({
        url : '/newsInfo/selectByHomeId',
        method : 'post',
        data,
    });
}






export default {
    getHomeNews,
    getPageNews,
    selectByHomeId
}